import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M21 3C22.1 3 23 3.9 23 5L22.9902 16.5654C22.9222 16.4759 22.8493 16.3883 22.7676 16.3066C22.2792 15.8184 21.6397 15.5761 21 15.5771V5H3V17H11.6885C11.2751 17.8571 11.3769 18.9004 11.999 19.6631L12.1709 19.8525L13.3184 21H8V19H3C1.9 19 1 18.1 1 17V5C1 3.9 1.9 3 3 3H21ZM7 12V14H5V12H7ZM15.0762 12C15.0034 12.2344 14.9639 12.4838 14.9639 12.7422V14H8V12H15.0762ZM7 8V10H5V8H7ZM19 8V10H8V8H19Z" />
    <path
      d="M17.4645 12.7421L17.4645 19.8525M13.9388 18.0847L17.4744 21.6203M17.4645 21.6102L21 18.0747"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </>,
  'DesktopUIDownload',
)
